﻿import { ProductType, ResultType } from 'features/searchResultsFacets';
import HousingDevelopmentMarker from '../models/housingDevelopmentMarker';
import BuildablePlanMarker from '../models/buildablePlanMarker';
import PlanUnitMarker from '../models/planUnitMarker';
import SpecUnitMarker from '../models/specUnitMarker';
import MarkerType from '../enums/markerType';

/**
 * It filters out plans that are in the buildablePlans array from the plans array.
 * @param plans - An array of plans.
 * @param buildablePlans - An array of Housing Developments that has more than one plan.
 */
export const filterPlansFromBuildablePlans = (plans, buildablePlans) =>
  plans.filter((plan) => !buildablePlans.some((x) => x.GeoId === plan.GeoId));

/**
 * Get all housing developments that have more than one plan.
 * @param housingDevelopments - An array of housing developments.
 */
export const getAllBuildablePlans = (housingDevelopments, plans) => {
  const featuredPlans = plans.filter(plan => plan.IsFeaturedListing).map(plan => plan.GeoId);
  const buildablePlans = housingDevelopments.filter((x) => x.TotalPlans > 1);
  
  buildablePlans.filter(plan => featuredPlans.includes(plan.GeoId)).forEach(element => {
    element.IsFeaturedListing = true;
  });

  return buildablePlans;
} ;

/**
 * If the productType is 'communities', then create a new HousingDevelopmentMarker, otherwise create a
 * new HousingUnitMarker.
 * @param productType - 'communities' or 'homes'
 * @param allHousing - an array of objects
 * @returns An array of objects.
 */
export const getMarkers = (productType, allHousing) => {
  const isCommunitiesSearch = productType === ResultType.Communities.toString();
  const markers = [
    ...allHousing.specs.map((spec) => new SpecUnitMarker(spec)),
    ...allHousing.plans.map((plan) => new PlanUnitMarker(plan)),
    ...allHousing.buildablePlans.map((b) => new BuildablePlanMarker(b)),
  ];

  if (isCommunitiesSearch) {
    return allHousing.communities.map((housing) => new HousingDevelopmentMarker(housing));
  }

  return markers;
};


export const updatePageNumberOfMarkers = (productType, allHousing, markers) => {
  const isCommunitiesSearch = productType === ProductType.Communities.toString();
  const communityMarkers = markers.filter((marker) => marker.type === MarkerType.HousingDevelopment.toString());
  if (!isCommunitiesSearch ||
    !allHousing?.communities ||
    communityMarkers.length !== markers.length ||
    allHousing.communities.length !== markers.length) {
    return;
  }

  for (let i = 0; i < markers.length; i+=1) {
    const marker = markers[i];
    const sourceMarker = allHousing.communities[i];
    if(sourceMarker.Id === marker.id){
      marker.pageNumber = sourceMarker.Page;
    }
    else{
      const newPage = allHousing.communities.find((housing) => housing.Id === marker.id)?.Page;
      marker.pageNumber = newPage ?? marker.pageNumber;
    }      
  }
};